import React, { useEffect } from 'react';
import Icon from '../Icon/Icon';
import * as styles from './YoutubePopup.module.scss';
const YoutubePopup = _ref => {
  let {
    id,
    isOpen,
    handler
  } = _ref;
  if (!id) {
    return false;
  }
  useEffect(() => {
    const handleKeyDown = event => {
      if (event.key === 'Escape' || event.keyCode === 27) {
        handler();
      }
    };
    if (isOpen) {
      window.addEventListener('keydown', handleKeyDown);
    }
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isOpen, handler]);
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root}`
  }, isOpen && /*#__PURE__*/React.createElement("div", {
    className: `${styles.rootPlayer}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.rootOverlay,
    onClick: handler
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.rootVideo
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    classname: styles.rootClose,
    onClick: handler
  }), /*#__PURE__*/React.createElement("iframe", {
    src: `https://www.youtube.com/embed/${id}?autoplay=1`,
    title: "YouTube video player",
    allow: "autoplay",
    allowFullScreen: true
  }))));
};
export default YoutubePopup;